import { useAppSelector } from '../store/hooks'
import MaximumDrawdownStateless from '../templates/maximum-drawdown-stateless'

export const MaximumDrawdownPage = () => {
  const state = useAppSelector(x => x.gapRisk)

  return <MaximumDrawdownStateless isLoading={false} report={state.maxDrawdownReport} />
}
